var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"6374a3fa0aa8b1bb1c8ced7d93b1ed78eb2f3a58"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["kfh-gatsby@fresh-egg-limited"]={id:"6374a3fa0aa8b1bb1c8ced7d93b1ed78eb2f3a58"};
      